if (!customElements.get('featured-collections-large')) {
  class FeaturedCollectionsLarge extends HTMLElement {
    constructor() {
      super();
      this.items = null;
      this.backgrounds = null;
      this.defaultBackground = null;
    }

    connectedCallback() {
      this.items = this.querySelectorAll('.featured-collections-large__item');
      this.backgrounds = this.querySelectorAll('.featured-collections-large__background');
      this.defaultBackground = this.querySelector('.featured-collections-large__background--default');
      
      if (this.items.length > 0) {
        this.init();
      }
    }

    disconnectedCallback() {
      this.cleanup();
    }

    init() {
      this.items.forEach(item => {
        item.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
      });
      
      this.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
    }

    cleanup() {
      this.items.forEach(item => {
        item.removeEventListener('mouseenter', this.handleMouseEnter.bind(this));
      });
      
      this.removeEventListener('mouseleave', this.handleMouseLeave.bind(this));
    }

    handleMouseEnter(event) {
      const item = event.currentTarget;
      const index = item.dataset.collectionIndex;
      
      // Hide all backgrounds
      this.backgrounds.forEach(bg => {
        bg.style.opacity = '0';
      });
      
      // Show the hovered collection's background
      const targetBackground = this.querySelector(
        `.featured-collections-large__background[data-collection-index="${index}"]`
      );
      
      if (targetBackground) {
        targetBackground.style.opacity = '1';
      } else if (this.defaultBackground) {
        // If no hover image, keep default visible
        this.defaultBackground.style.opacity = '1';
      }
    }

    handleMouseLeave() {
      // Hide all backgrounds
      this.backgrounds.forEach(bg => {
        bg.style.opacity = '0';
      });
      
      // Show default background
      if (this.defaultBackground) {
        this.defaultBackground.style.opacity = '1';
      }
    }
  }

  customElements.define('featured-collections-large', FeaturedCollectionsLarge);
}

// Handle Shopify theme editor section events
if (Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const component = event.target.querySelector('featured-collections-large');
    if (component) {
      // Re-initialize the component
      component.connectedCallback();
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const component = event.target.querySelector('featured-collections-large');
    if (component) {
      component.disconnectedCallback();
    }
  });
}
